import { call, put, takeLatest } from 'redux-saga/effects';
import { setLoading, showSnackbar, toggleModal } from 'reducers/ui';
import { errorHandler } from 'utils/errorMessages';
import API from 'services/api';
import get from 'lodash/get';
import {
  regionActions,
  regionPageActions,
} from 'containers/Pages/Region/Region';
import { setRegionDetails } from 'reducers/region';
import { transformRegionDetails } from 'utils/DataTransform/Region/RegionDetails';
import { setDefaultTimezone } from 'reducers/utils';
import { PAGE_URLS } from 'utils/constants';
import { isEmpty } from 'lodash';

export function* fetchRegionListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { filters, from } = payload;
    const { data } = yield call(API.fetchRegionList, { ...filters, from });
    const totalEntries = get(data, 'meta.total');
    if (data.data !== null) {
      yield put(regionActions.setGridList({ list: data.data, totalEntries }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* fetchRegionDetailsSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    const { data } = yield call(API.fetchRegionDetails, id);
    if (data.data) {
      yield put(regionActions.setGridRowDetails({ details: data.data }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* fetchUsersRegionSaga({ payload }) {
  try {
    const { id } = payload;
    const { data } = yield call(API.fetchRegionDetails, id);
    if (data.data !== null) {
      yield put(setRegionDetails(transformRegionDetails(data.data)));
      const defaultTimezone = get(data.data, 'defaultTimeZone');
      yield put(setDefaultTimezone(defaultTimezone));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}

export function* createOrUpdateRegionSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { region } = payload;
    let result = 500;
    if (isEmpty(region.id)) {
      const { status } = yield call(API.createRegion, region);
      result = status;
    } else {
      const { status } = yield call(API.updateRegion, region);
      result = status;
    }
    if (result === 200) {
      yield put(toggleModal(PAGE_URLS.REGION.name));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* regionSagas() {
  yield takeLatest(regionActions.fetchGridRowDetails, fetchRegionDetailsSaga);
  yield takeLatest(regionActions.fetchGridList, fetchRegionListSaga);
  yield takeLatest(regionPageActions.fetchUsersRegion, fetchUsersRegionSaga);
  yield takeLatest(regionActions.createRowEntry, createOrUpdateRegionSaga);
  yield takeLatest(regionActions.updateRowEntry, createOrUpdateRegionSaga);
}
